(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-share')) {
    class ProductShare extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.trigger = this.querySelector('[data-share-trigger]');
        this.dialog = this.querySelector('[data-share-dialog]');
        this.closeButton = this.querySelector('[data-share-close]');
        this.copyButton = this.querySelector('[data-share-copy]');
        this.linkInput = this.querySelector('[data-share-link]');
        this.copyLabel = this.querySelector('[data-share-copy-label]');
        this.status = this.querySelector('[data-share-status]');
        this.trigger?.addEventListener('click', () => this.dialog?.showModal());
        this.closeButton?.addEventListener('click', () => this.dialog?.close());
        this.dialog?.addEventListener('click', (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
          if (outside) this.dialog.close();
        });
        this.copyButton?.addEventListener('click', () => this.copyLink());
      }

      async copyLink() {
        const value = this.dataset.shareUrl;
        try {
          await navigator.clipboard.writeText(value);
        } catch (error) {
          this.linkInput.focus();
          this.linkInput.select();
          document.execCommand('copy');
        }
        this.copyLabel.textContent = this.dataset.copiedLabel;
        this.status.textContent = this.dataset.copiedLabel;
        window.setTimeout(() => {
          this.copyLabel.textContent = this.dataset.copyLabel;
          this.status.textContent = '';
        }, 2200);
      }
    }

    customElements.define('product-share', ProductShare);
  }
  } catch(e) { console.error(e); }
})();

})();
